import { useState } from "react";
import { createClient } from "@supabase/supabase-js";

// ─── One Supabase client per app (each app lives in its own project) ──────────
const CLIENTS = {
  all: null, // resolved at send time — fires all four
  jamb: createClient(
    "https://deymsyfdueakauhatlrk.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRleW1zeWZkdWVha2F1aGF0bHJrIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0NjczMzEyMSwiZXhwIjoyMDYyMzA5MTIxfQ.ZSvYRPtHCmGDkiDTc4ZjZypCsaRcRy4z-k1iGIlHekE",
  ),
  waec: createClient(
    "https://ueibcpnyorkhqwsmkeza.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVlaWJjcG55b3JraHF3c21rZXphIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcyNzA3MjkwNCwiZXhwIjoyMDQyNjQ4OTA0fQ.H4jStCH8w2IyaKjV_BXMlckWL8xUDXFRA_u0ggw8oXg",
  ),
  neco: createClient(
    "https://uibgpqgajbznxatdamzx.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVpYmdwcWdhamJ6bnhhdGRhbXp4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5MTAwOTIsImV4cCI6MjA5MTQ4NjA5Mn0.r38ihHY0ohac0brSFc623rbAIAmi0M9Yxu3sTJnm_bg",
  ),
  post_utme: null, // no dedicated project yet — extend here when ready
};

// Edge function name per app
const FUNCTIONS = {
  jamb: "clever-task",
  waec: "rapid-processor",
  neco: "dynamic-action",
  post_utme: null,
};

// ─── Password gate ────────────────────────────────────────────────────────────
// To change: run [...'yourpassword'].map(c => c.charCodeAt(0)) in the console
const _PW = [
  114, 101, 118, 101, 114, 101, 110, 100, 105, 110, 115, 97, 110, 105, 116, 121,
];
const ADMIN_PW = String.fromCharCode(..._PW);

// ─── App config ───────────────────────────────────────────────────────────────
const APP_OPTIONS = [
  {
    value: "all",
    label: "All Apps",
    description: "JAMB, WAEC & NECO",
    emoji: "📢",
  },
  {
    value: "jamb",
    label: "JAMB CBT",
    description: "JAMB / UTME users",
    emoji: "🧠",
  },
  { value: "waec", label: "WAEC CBT", description: "WAEC users", emoji: "📚" },
  { value: "neco", label: "NECO CBT", description: "NECO users", emoji: "📖" },
  {
    value: "post_utme",
    label: "Post-UTME",
    description: "Coming soon",
    emoji: "🏛️",
    disabled: true,
  },
];

// ─── Styles ───────────────────────────────────────────────────────────────────
const ls = {
  overlay: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  box: {
    background: "rgba(255,255,255,0.07)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 20,
    padding: "40px 32px",
    width: "100%",
    maxWidth: 360,
    boxShadow: "0 32px 80px rgba(0,0,0,0.4)",
    textAlign: "center",
  },
  lockIcon: { fontSize: 36, marginBottom: 12 },
  heading: { fontSize: 20, fontWeight: 700, color: "#fff", margin: "0 0 6px" },
  sub: { fontSize: 13, color: "rgba(255,255,255,0.4)", margin: "0 0 28px" },
  pwInput: (err) => ({
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: err
      ? "1px solid rgba(239,68,68,0.6)"
      : "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontSize: 15,
    boxSizing: "border-box",
    outline: "none",
    marginBottom: 12,
    letterSpacing: "0.1em",
    textAlign: "center",
  }),
  pwBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: 10,
    border: "none",
    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer",
    boxShadow: "0 4px 20px rgba(99,102,241,0.35)",
  },
  pwError: { marginTop: 12, fontSize: 13, color: "#fca5a5" },
};

const s = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: "48px 16px",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  card: {
    background: "rgba(255,255,255,0.07)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 20,
    padding: "36px 32px",
    width: "100%",
    maxWidth: 520,
    boxShadow: "0 32px 80px rgba(0,0,0,0.4)",
  },
  badge: {
    display: "inline-block",
    background: "rgba(99,102,241,0.25)",
    border: "1px solid rgba(99,102,241,0.4)",
    color: "#a5b4fc",
    borderRadius: 100,
    padding: "4px 14px",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.06em",
    marginBottom: 14,
    textTransform: "uppercase",
  },
  title: { fontSize: 26, fontWeight: 700, color: "#fff", margin: "0 0 6px" },
  subtitle: {
    fontSize: 14,
    color: "rgba(255,255,255,0.5)",
    margin: "0 0 32px",
  },
  label: {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    color: "rgba(255,255,255,0.75)",
    marginBottom: 8,
    letterSpacing: "0.04em",
  },
  input: {
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
  },
  textarea: {
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.15)",
    background: "rgba(255,255,255,0.06)",
    color: "#fff",
    fontSize: 14,
    boxSizing: "border-box",
    outline: "none",
    resize: "vertical",
    fontFamily: "inherit",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    marginBottom: 24,
  },
  appOption: (selected, disabled) => ({
    padding: "12px 14px",
    borderRadius: 12,
    border: selected
      ? "1.5px solid #818cf8"
      : "1px solid rgba(255,255,255,0.1)",
    background: selected ? "rgba(99,102,241,0.2)" : "rgba(255,255,255,0.04)",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.4 : 1,
    transition: "all 0.18s",
    display: "flex",
    alignItems: "center",
    gap: 10,
    userSelect: "none",
  }),
  appLabel: (selected) => ({
    fontSize: 13,
    fontWeight: 600,
    color: selected ? "#e0e7ff" : "rgba(255,255,255,0.7)",
    display: "block",
  }),
  appDesc: {
    fontSize: 11,
    color: "rgba(255,255,255,0.35)",
    display: "block",
    marginTop: 2,
  },
  dot: (selected) => ({
    width: 16,
    height: 16,
    borderRadius: "50%",
    flexShrink: 0,
    border: selected ? "none" : "1.5px solid rgba(255,255,255,0.2)",
    background: selected ? "#818cf8" : "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  divider: {
    height: 1,
    background: "rgba(255,255,255,0.08)",
    margin: "24px 0",
  },
  submitBtn: (loading) => ({
    width: "100%",
    padding: "14px",
    borderRadius: 12,
    border: "none",
    background: loading
      ? "rgba(99,102,241,0.35)"
      : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
    color: loading ? "rgba(255,255,255,0.4)" : "#fff",
    fontSize: 15,
    fontWeight: 600,
    cursor: loading ? "not-allowed" : "pointer",
    boxShadow: loading ? "none" : "0 4px 20px rgba(99,102,241,0.35)",
    transition: "all 0.2s",
  }),
  successBox: {
    padding: "14px 16px",
    background: "rgba(52,211,153,0.12)",
    border: "1px solid rgba(52,211,153,0.3)",
    borderRadius: 10,
    color: "#6ee7b7",
    fontSize: 14,
    marginBottom: 20,
    lineHeight: 1.6,
  },
  errorBox: {
    padding: "14px 16px",
    background: "rgba(239,68,68,0.12)",
    border: "1px solid rgba(239,68,68,0.3)",
    borderRadius: 10,
    color: "#fca5a5",
    fontSize: 14,
    marginBottom: 20,
    lineHeight: 1.6,
  },
  historyHeader: {
    fontSize: 13,
    fontWeight: 600,
    color: "rgba(255,255,255,0.4)",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    marginBottom: 10,
  },
  historyItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    background: "rgba(255,255,255,0.04)",
    borderRadius: 8,
    marginBottom: 6,
    gap: 10,
  },
  historyTarget: { fontSize: 13, color: "rgba(255,255,255,0.7)", flex: 1 },
  historyBadge: (app) => ({
    fontSize: 11,
    fontWeight: 600,
    padding: "3px 8px",
    borderRadius: 100,
    background: app === "all" ? "rgba(99,102,241,0.3)" : "rgba(52,211,153,0.2)",
    color: app === "all" ? "#a5b4fc" : "#6ee7b7",
    whiteSpace: "nowrap",
    flexShrink: 0,
  }),
  historyTime: {
    fontSize: 11,
    color: "rgba(255,255,255,0.25)",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
function fmtTime(ts) {
  return new Intl.DateTimeFormat("en-NG", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    day: "2-digit",
    month: "short",
  }).format(new Date(ts));
}

async function sendToApp(appKey, title, body) {
  const client = CLIENTS[appKey];
  const fn = FUNCTIONS[appKey];
  if (!client || !fn) return { sent: 0, skipped: true };
  const { data, error } = await client.functions.invoke(fn, {
    body: { title, body },
  });
  if (error) throw new Error(`[${appKey}] ${error.message}`);
  return data;
}

// ─── Component ────────────────────────────────────────────────────────────────
export default function AdminNotifications() {
  // Lock screen state
  const [unlocked, setUnlocked] = useState(false);
  const [pwInput, setPwInput] = useState("");
  const [pwError, setPwError] = useState(false);

  // Form state
  const [app, setApp] = useState("all");
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [history, setHistory] = useState([]);

  // ── Unlock ──────────────────────────────────────────────────────────────
  const handleUnlock = () => {
    if (pwInput === ADMIN_PW) {
      setUnlocked(true);
    } else {
      setPwError(true);
      setPwInput("");
      setTimeout(() => setPwError(false), 2000);
    }
  };

  if (!unlocked) {
    return (
      <div style={ls.overlay}>
        <div style={ls.box}>
          <div style={ls.lockIcon}>🔐</div>
          <h2 style={ls.heading}>Admin Access</h2>
          <p style={ls.sub}>Enter the admin password to continue.</p>
          <input
            type="password"
            value={pwInput}
            onChange={(e) => setPwInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleUnlock()}
            placeholder="••••••••"
            style={ls.pwInput(pwError)}
            autoFocus
          />
          <button style={ls.pwBtn} onClick={handleUnlock}>
            Unlock
          </button>
          {pwError && <p style={ls.pwError}>❌ Incorrect password</p>}
        </div>
      </div>
    );
  }

  // ── Send ────────────────────────────────────────────────────────────────
  const handleSend = async () => {
    if (!title.trim() || !body.trim()) {
      setError("Title and message are required.");
      return;
    }
    setLoading(true);
    setResult(null);
    setError(null);

    const targets =
      app === "all"
        ? Object.keys(CLIENTS).filter(
            (k) => k !== "all" && CLIENTS[k] && FUNCTIONS[k],
          )
        : [app];

    try {
      const results = await Promise.all(
        targets.map((t) => sendToApp(t, title.trim(), body.trim())),
      );
      const totalSent = results.reduce((sum, r) => sum + (r?.sent ?? 0), 0);
      const entry = {
        app,
        title: title.trim(),
        ts: Date.now(),
        sent: totalSent,
      };
      setResult(entry);
      setHistory((h) => [entry, ...h].slice(0, 20));
      setTitle("");
      setBody("");
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to send notification.");
    } finally {
      setLoading(false);
    }
  };

  // ── Render ──────────────────────────────────────────────────────────────
  return (
    <div style={s.page}>
      <div style={s.card}>
        {/* Header */}
        <div style={s.badge}>⚡ Admin · Notifications</div>
        <h1 style={s.title}>Send Notification</h1>
        <p style={s.subtitle}>
          Push a message to all users of one app or every app at once.
        </p>

        {/* Alerts */}
        {result && (
          <div style={s.successBox}>
            ✅ Sent to <strong>{result.sent} users</strong> via{" "}
            <strong>
              {result.app === "all"
                ? "JAMB, WAEC & NECO"
                : APP_OPTIONS.find((o) => o.value === result.app)?.label}
            </strong>
            .
          </div>
        )}
        {error && <div style={s.errorBox}>❌ {error}</div>}

        {/* App picker */}
        <div style={{ marginBottom: 8 }}>
          <label style={s.label}>Send To</label>
        </div>
        <div style={s.grid}>
          {APP_OPTIONS.map((opt) => {
            const sel = app === opt.value;
            return (
              <div
                key={opt.value}
                style={{
                  ...s.appOption(sel, opt.disabled),
                  ...(opt.value === "all" ? { gridColumn: "1 / -1" } : {}),
                }}
                onClick={() => !opt.disabled && setApp(opt.value)}
                role="radio"
                aria-checked={sel}
                tabIndex={opt.disabled ? -1 : 0}
                onKeyDown={(e) =>
                  e.key === " " && !opt.disabled && setApp(opt.value)
                }
              >
                <span style={{ fontSize: 20 }}>{opt.emoji}</span>
                <span style={{ flex: 1 }}>
                  <span style={s.appLabel(sel)}>{opt.label}</span>
                  <span style={s.appDesc}>{opt.description}</span>
                </span>
                <span style={s.dot(sel)}>
                  {sel && (
                    <svg width="8" height="8" viewBox="0 0 8 8">
                      <circle cx="4" cy="4" r="4" fill="#fff" />
                    </svg>
                  )}
                </span>
              </div>
            );
          })}
        </div>

        {/* Title */}
        <div style={{ marginBottom: 16 }}>
          <label style={s.label}>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
              setError(null);
            }}
            placeholder="e.g. New feature available!"
            style={s.input}
          />
        </div>

        {/* Body */}
        <div style={{ marginBottom: 24 }}>
          <label style={s.label}>Message</label>
          <textarea
            value={body}
            onChange={(e) => {
              setBody(e.target.value);
              setError(null);
            }}
            placeholder="e.g. Check out the new study materials we just added!"
            rows={4}
            style={s.textarea}
          />
        </div>

        {/* Submit */}
        <button
          style={s.submitBtn(loading)}
          disabled={loading}
          onClick={handleSend}
        >
          {loading ? "Sending…" : "📨 Send Notification"}
        </button>

        {/* Session log */}
        {history.length > 0 && (
          <>
            <div style={s.divider} />
            <p style={s.historyHeader}>Session Log</p>
            {history.map((h, i) => (
              <div key={i} style={s.historyItem}>
                <span style={s.historyTarget}>"{h.title}"</span>
                <span style={s.historyBadge(h.app)}>
                  {h.app === "all"
                    ? "All apps"
                    : APP_OPTIONS.find((o) => o.value === h.app)?.label}
                </span>
                <span
                  style={{
                    ...s.historyBadge("sent"),
                    background: "rgba(255,255,255,0.08)",
                    color: "rgba(255,255,255,0.4)",
                  }}
                >
                  {h.sent} sent
                </span>
                <span style={s.historyTime}>{fmtTime(h.ts)}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
